import React from "react";

// =====================================================================
// Verbatim artboard glyphs for the Club-Network club-side rebuild
// (Redesign 2.0, "TransferPitch Club Side v3.dc.html" — SPEC-EXTRACT §2.1).
// Brief RULE 2 — zero tolerance: every SVG below is copied 1:1 from the
// handoff, never swapped for a look-alike platform icon. Size variants are
// exactly the ones the boards use (identical paths, only width/height vary).
//
// NOTE: the request CARD keeps the shipped V2 glyph set from
// `components/agent-tender/glyphs.jsx` per SPEC-EXTRACT §9 (RequestCard
// RESOLUTION) — these v3 glyphs serve the club-side chrome around it
// (CS1 pills, contacted marker, feed empty state, N2-2 detail, N3 boards).
// =====================================================================

// S1 — Trust seal (shield + check), the Club Verified glyph.
// Variants: 13×15 (CS1 hero) · 11×13 (card/detail badges) · 15×18 (C1
// notification disc) · 22×26 (C2 result disc).
export const TrustSealGlyph = ({ width = 11, height = 13, className = "" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 14"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M6 0.5L11 2.4V6c0 3.3-2.1 6.1-5 7.5C3.1 12.1 1 9.3 1 6V2.4L6 0.5Z"
      fill="#047857"
    />
    <path
      d="M3.8 6.6l1.5 1.5 2.9-3"
      stroke="#ECFDF5"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

// S2 — Chat bubble (contacted marker 12×12 · contacted banner 14×14).
export const ChatBubbleGlyph = ({ size = 12, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M2 2.5h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H5l-3 2.5v-9.5a1 1 0 0 1 1-1Z"
      stroke="#2283FF"
      strokeWidth="1.4"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

// S3 — Search magnifier. Gray (#9CA3AF) by default; the N3-4e empty state
// uses the blue variant (both strokes #2283FF). 14×14 (search bars) ·
// 13×13 (picker) · 19×19 (empty-state discs).
export const MagnifierGlyph = ({ size = 14, stroke = "#9CA3AF", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <circle cx="6" cy="6" r="4.4" stroke={stroke} strokeWidth="1.6" fill="none" />
    <path d="M9.5 9.5L13 13" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

// S4 — Checkmark. 10×8 white (desktop checkbox) · 11×9 white (mobile
// checkbox M6) · 18×14 #16A34A (sent/success discs N2-3c, N3-5c).
export const CheckGlyph = ({
  width = 10,
  height = 8,
  stroke = "#FFFFFF",
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 8"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M1 4l2.7 2.7L9 1"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// S5 — Envelope (agent inbox empty state N3-6e, 20×20 in a 50px disc).
export const EnvelopeGlyph = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <rect
      x="2"
      y="4"
      width="14"
      height="10"
      rx="2"
      stroke="#9CA3AF"
      strokeWidth="1.6"
      fill="none"
    />
    <path
      d="M2 6l7 4 7-4"
      stroke="#9CA3AF"
      strokeWidth="1.6"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);
